module.exports = __webpack_public_path__ + "../resources/img/guideStep1.58e46897.png";